import {IssuesSafeViewer} from '@github-ui/server-persisted-queries'
import type {IssuesSafeViewerQuery} from '@github-ui/server-persisted-queries/types/IssuesSafeViewer'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

export type SafeViewer = NonNullable<IssuesSafeViewerQuery['safeViewer']>

export function safeViewerQueryKey() {
  return ['item-picker-assignee', 'safe-viewer'] as const
}

export async function fetchSafeViewer(signal?: AbortSignal): Promise<SafeViewer | null> {
  const response = await verifiedFetchJSON(`/issues/viewer?queryId=${IssuesSafeViewer}`, {signal})
  if (!response.ok) throw new Error(`Safe viewer fetch failed (${response.status}) for ${response.url}`)

  const json = (await response.json()) as {data?: IssuesSafeViewerQuery; errors?: unknown[]}
  if (json.errors?.length || !json.data) throw new Error('Safe viewer query returned errors')

  return json.data.safeViewer ?? null
}
